"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loader = void 0;

require("@albelli/arc-3/lib/core.css");

require("@albelli/arc-3/lib/loader.css");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Loader = function Loader(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? "ultra-large" : _ref$size,
      spaceHolder = _ref.spaceHolder,
      _ref$container = _ref.container,
      container = _ref$container === void 0 ? true : _ref$container,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["size", "spaceHolder", "container", "className"]);

  var ua = window && window.navigator.userAgent;
  var isIE = ua && (ua.indexOf("MSIE ") >= 0 || ua.indexOf("Trident/") >= 0 || ua.indexOf("Edge/") >= 0);
  var loaderClass = isIE ? "arc3-loader-simple" : "arc3-loader";

  var loader = _react.default.createElement("div", _extends({
    className: (0, _classnames.default)(loaderClass, "arc3-loader--" + size, className)
  }, props));

  var result = container ? _react.default.createElement("div", {
    className: "arc3-loader-placement"
  }, loader) : loader;
  return spaceHolder ? _react.default.createElement("div", {
    className: "arc3-loader-spaceholder"
  }, result) : result;
};

exports.Loader = Loader;
Loader.propTypes = {
  /** Sizing of loader */
  size: _propTypes.default.oneOf(["ultra-small", "extra-small", "small", "medium", "large", "extra-large", "ultra-large"]),

  /** Should place in the containing div, defaults to true */
  container: _propTypes.default.bool
};